<template>
    <slot v-bind="{
        ...state,
    }" />
</template>

<script setup>
import { onBeforeMount, reactive } from 'vue';

import { getUpcomingInstances } from '../services/inventory';
import { hasMemberships, hasSubscriptions } from '../utils/cookies';

const state = reactive({
    isLoading: true,
    hasMemberships: false,
    hasSubscriptions: false,
    upcomingEvent: false,
});

onBeforeMount(() => {
    state.hasMemberships = hasMemberships();
    state.hasSubscriptions = hasSubscriptions();

    getUpcomingInstances().then(instances => {
        const upcomingEvents = instances.filter(instance => {
            return instance.isAttending;
        });

        if (upcomingEvents.length) {
            state.upcomingEvent = upcomingEvents[0];
        }
    }).finally(() => {
        state.isLoading = false;
    });
});
</script>
